module.exports = __webpack_public_path__ + "img/1970East-065_WEB-min.f19b709f.jpg";